import { AdminLayout } from '@/layouts/admin/admin-layout'
import SupportPage from '@/pages/support/support-page'
import StorageFilesPage from '@/pages/admin/core/storage/storage-files-page'
import StorageSharesPage from '@/pages/admin/core/storage/storage-shares-page'
import StorageSettingsPage from '@/pages/admin/core/storage/storage-settings-page'
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useParams,
} from 'react-router-dom'
// Commerce
import ProductCategoryFormPage from '@/pages/admin/commerce/product-categories/product-category-form-page'
import ProductCategoryListPage from '@/pages/admin/commerce/product-categories/product-category-list-page'
// Promoções e Cupons
import PromosListPage from '@/pages/admin/commerce/promos/promos-list-page'
import PromosFormPage from '@/pages/admin/commerce/promos/promos-form-page'
import CouponsListPage from '@/pages/admin/commerce/coupons/coupons-list-page'
import CouponsFormPage from '@/pages/admin/commerce/coupons/coupons-form-page'
// Loja Online
import ShippingConfigPage from '@/pages/admin/commerce/shop/shipping-config-page'
import StoreSettingsPage from '@/pages/admin/commerce/shop/store-settings-page'
import StoreThemePage from '@/pages/admin/commerce/shop/store-theme-page'
import StoreThemesPage from '@/pages/admin/commerce/shop/store-themes-page'
import StoreNewsletterPage from '@/pages/admin/commerce/newsletter/store-newsletter-page'
import StoresListPage from '@/pages/admin/commerce/shop/stores-list-page'
import WidgetFormPage from '@/pages/admin/commerce/shop/widget-form-page'
import WidgetsListPage from '@/pages/admin/commerce/shop/widgets-list-page'
// Atendimento
import AgendaPage from '@/pages/admin/atendimento/agenda/agenda'
import AgendaSettingsPage from '@/pages/admin/atendimento/agenda/agenda-settings-page'
import AtendimentoChatPage from '@/pages/admin/atendimento/atendimentos/atendimento-chat-page'
import AtendimentosPage from '@/pages/admin/atendimento/atendimentos/atendimentos-page'
import ConversationSimulatorPage from '@/pages/admin/atendimento/conversation-simulator/conversation-simulator-page'
import WelcomePage from '@/pages/admin/core/home/welcome-page'
import AttendantsFormPage from '@/pages/admin/atendimento/attendants/attendants-form-page'
import AttendantsListPage from '@/pages/admin/atendimento/attendants/attendants-list-page'
import DepartmentsFormPage from '@/pages/admin/atendimento/departments/departments-form-page'
import DepartmentsListPage from '@/pages/admin/atendimento/departments/departments-list-page'
import IntegrationFormPage from '@/pages/admin/atendimento/integrations/integration-form-page'
import IntegrationsPage from '@/pages/admin/atendimento/integrations/integrations-page'
import RoomFormPage from '@/pages/admin/atendimento/rooms/room-form-page'
import RoomListPage from '@/pages/admin/atendimento/rooms/room-list-page'
// Person
import ClientDetailPage from '@/pages/admin/person/clients/client-detail-page'
import ClientFormPage from '@/pages/admin/person/clients/client-form-page'
import ClientsPage from '@/pages/admin/person/clients/clients-page'
import EmployeesFormPage from '@/pages/admin/person/users/users-form-page'
import EmployeesListPage from '@/pages/admin/person/users/users-list-page'
import PartnerDetailPage from '@/pages/admin/person/partners/partner-detail-page'
import PartnersFormPage from '@/pages/admin/person/partners/partners-form-page'
import PartnersListPage from '@/pages/admin/person/partners/partners-list-page'
import ProfessionalDetailPage from '@/pages/admin/person/professionals/professional-detail-page'
import ProfessionalFormPage from '@/pages/admin/person/professionals/professional-form-page'
import ProfessionalsPage from '@/pages/admin/person/professionals/professionals-page'
import SupplierDetailPage from '@/pages/admin/person/suppliers/supplier-detail-page'
import SupplierFormPage from '@/pages/admin/person/suppliers/supplier-form-page'
import SuppliersPage from '@/pages/admin/person/suppliers/suppliers-page'
// Core
import AccountPage from '@/pages/admin/core/account/account-page'
import SystemStorePage from '@/pages/admin/core/system-store/system-store-page'
import DashboardPage from '@/pages/admin/core/dashboard/dashboard-page'
import ImportReviewPage from '@/pages/admin/core/import-review/import-review-page'
import InternalChatPage from '@/pages/admin/core/internal-chat/internal-chat-page'
import NotificationFormPage from '@/pages/admin/core/notifications/notification-form-page'
import NotificationsPage from '@/pages/admin/core/notifications/notifications-page'
import DataReportsPage from '@/pages/admin/core/reports/reports-page'
import ReportAutomationsPage from '@/pages/admin/core/reports/automations/automations-page'
import SearchResultsPage from '@/pages/admin/core/search/search-results-page'
import CompanyUnitFormPage from '@/pages/admin/core/units/unit-form-page'
import CompanyUnitsPage from '@/pages/admin/core/units/units-page'
// Medical
import CertificatesPage from '@/pages/admin/registrations/certificates/certificates-page'
import TemplatesPage from '@/pages/admin/registrations/templates/templates-page'
import LetterheadsListPage from '@/pages/admin/registrations/letterheads/letterheads-list-page'
import LetterheadsFormPage from '@/pages/admin/registrations/letterheads/letterheads-form-page'
import CatalogFormPage from '@/pages/admin/bookings/catalog/catalog-form-page'
import CatalogDetailPage from '@/pages/admin/bookings/catalog/catalog-detail-page'
import CatalogListPage from '@/pages/admin/bookings/catalog/catalog-list-page'
import CatalogStockPage from '@/pages/admin/bookings/catalog/catalog-stock-page'
import CounterSalePage from '@/pages/admin/commerce/counter-sale/counter-sale-page'
import VariationsPricingPage from '@/pages/admin/bookings/catalog/variations-pricing-page'
import CatalogTypeFormPage from '@/pages/admin/bookings/catalog-type/catalog-type-form-page'
import CatalogTypeListPage from '@/pages/admin/bookings/catalog-type/catalog-type-list-page'
import MedicalSettingsPage from '@/pages/admin/bookings/settings/medical-settings-page'
import SchedulingFormPage from '@/pages/admin/bookings/scheduling/scheduling-form-page'
import ConsultationDetailPage from '@/pages/admin/bookings/consultations/consultation-detail-page'
import ConsultationRoomPage from '@/pages/admin/bookings/consultations/consultation-room-page'
import ConsultationsPage from '@/pages/admin/bookings/consultations/consultations-page'
import ExamDetailPage from '@/pages/admin/bookings/exams/exam-detail-page'
import ExamResultsPage from '@/pages/admin/bookings/exams/exam-results-page'
import ExamsPage from '@/pages/admin/bookings/exams/exams-page'
import PresencePage from '@/pages/admin/bookings/presence/presence-page'
import PackagesPage from '@/pages/admin/bookings/packages/packages-page'
import HealthPlanFormPage from '@/pages/admin/medical/health-plans/health-plan-form-page'
import HealthPlanListPage from '@/pages/admin/medical/health-plans/health-plan-list-page'
import MedicalSuppliesListPage from '@/pages/admin/registrations/medical-supplies/medical-supplies-list-page'
import MedicalSuppliesFormPage from '@/pages/admin/registrations/medical-supplies/medical-supplies-form-page'
import MedicalServicesListPage from '@/pages/admin/registrations/medical-services/medical-services-list-page'
import MedicalServicesFormPage from '@/pages/admin/registrations/medical-services/medical-services-form-page'
import EstablishmentsListPage from '@/pages/admin/registrations/establishments/establishments-list-page'
import EstablishmentsFormPage from '@/pages/admin/registrations/establishments/establishments-form-page'
import SupplierTypesListPage from '@/pages/admin/registrations/supplier-types/supplier-types-list-page'
import SupplierTypesFormPage from '@/pages/admin/registrations/supplier-types/supplier-types-form-page'
import PrescriptionDetailPage from '@/pages/admin/medical/prescriptions/prescription-detail-page'
import PrescriptionFormPage from '@/pages/admin/medical/prescriptions/prescription-form-page'
import PrescriptionsPage from '@/pages/admin/medical/prescriptions/prescriptions-page'
import OrderDetailPage from '@/pages/admin/bookings/orders/order-detail-page'
import OrdersPage from '@/pages/admin/bookings/orders/orders-page'
import CashClosingPage from '@/pages/admin/bookings/cash-closing/cash-closing-page'
import ReportDetailPage from '@/pages/admin/bookings/reports/report-detail-page'
import ReportFormPage from '@/pages/admin/bookings/reports/report-form-page'
import ReportsPage from '@/pages/admin/bookings/reports/reports-page'
import TeleconsultationDetailPage from '@/pages/admin/bookings/teleconsultation/teleconsultation-detail-page'
import TeleconsultationRoomPage from '@/pages/admin/bookings/teleconsultation/teleconsultation-room-page'
import TeleconsultationsPage from '@/pages/admin/bookings/teleconsultation/teleconsultations-page'
import TriageDetailPage from '@/pages/admin/bookings/triages/triage-detail-page'
import TriageFormPage from '@/pages/admin/bookings/triages/triage-form-page'
import TriagesPage from '@/pages/admin/bookings/triages/triages-page'
import SpecialtyFormPage from '@/pages/admin/person/specialties/specialty-form-page'
import SpecialtyListPage from '@/pages/admin/person/specialties/specialty-list-page'
import HospitalDetailPage from '@/pages/admin/registrations/hospitals/hospital-detail-page'
import HospitalFormPage from '@/pages/admin/registrations/hospitals/hospital-form-page'
import HospitalsPage from '@/pages/admin/registrations/hospitals/hospitals-page'
// Medical - Prontuário
import AlergiasPage from '@/pages/admin/medical/prontuario/AlergiasPage'
import AnamneseDetailPage from '@/pages/admin/medical/prontuario/AnamneseDetailPage'
import AnamneseFormPage from '@/pages/admin/medical/prontuario/AnamneseFormPage'
import AnamnesesPage from '@/pages/admin/medical/prontuario/AnamnesesPage'
import AnotacoesPage from '@/pages/admin/medical/prontuario/AnotacoesPage'
import AntecedentesPage from '@/pages/admin/medical/prontuario/AntecedentesPage'
import AtestadosPage from '@/pages/admin/medical/prontuario/AtestadosPage'
import ConsentimentosPage from '@/pages/admin/medical/prontuario/ConsentimentosPage'
import ConsultasPage from '@/pages/admin/medical/prontuario/ConsultasPage'
import ConveniosPage from '@/pages/admin/medical/prontuario/ConveniosPage'
import DiagnosticosPage from '@/pages/admin/medical/prontuario/DiagnosticosPage'
import EncaminhamentosPage from '@/pages/admin/medical/prontuario/EncaminhamentosPage'
import EvolucaoDetailPage from '@/pages/admin/medical/prontuario/EvolucaoDetailPage'
import EvolucaoFormPage from '@/pages/admin/medical/prontuario/EvolucaoFormPage'
import EvolucoesPage from '@/pages/admin/medical/prontuario/EvolucoesPage'
import HealthMapPage from '@/pages/admin/medical/prontuario/HealthMapPage'
import HealthMapSettingsPage from '@/pages/admin/medical/health-map/health-map-settings-page'
import ExamesPage from '@/pages/admin/medical/prontuario/ExamesPage'
import ProcedimentosPage from '@/pages/admin/medical/prontuario/ProcedimentosPage'
import ProntuarioLayout from '@/pages/admin/medical/prontuario/ProntuarioLayout'
import ProntuarioResumoPage from '@/pages/admin/medical/prontuario/ProntuarioResumoPage'
import ReceituarioPage from '@/pages/admin/medical/prontuario/ReceituarioPage'
import TimelinePage from '@/pages/admin/medical/prontuario/TimelinePage'
// Health Integrations
import HealthIntegrationsPage from '@/pages/admin/health-integrations/health-integrations-page'
import LabIntegrationFormPage from '@/pages/admin/health-integrations/lab-integration/lab-integration-form-page'
import LabIntegrationsPage from '@/pages/admin/health-integrations/lab-integration/lab-integrations-page'
import LabMessagesPage from '@/pages/admin/health-integrations/lab-integration/lab-messages-page'
import DicomStudiesPage from '@/pages/admin/health-integrations/pacs/dicom-studies-page'
import PacsFormPage from '@/pages/admin/health-integrations/pacs/pacs-form-page'
import PacsPage from '@/pages/admin/health-integrations/pacs/pacs-page'
import ElectronicPrescriptionsPage from '@/pages/admin/health-integrations/pharmacy/electronic-prescriptions-page'
import PharmacyFormPage from '@/pages/admin/health-integrations/pharmacy/pharmacy-form-page'
import PharmacyPage from '@/pages/admin/health-integrations/pharmacy/pharmacy-page'
import RndsFormPage from '@/pages/admin/health-integrations/rnds/rnds-form-page'
import RndsPage from '@/pages/admin/health-integrations/rnds/rnds-page'
import RndsTransactionsPage from '@/pages/admin/health-integrations/rnds/rnds-transactions-page'
import TissFormPage from '@/pages/admin/health-integrations/tiss/tiss-form-page'
import TissCredentialFormPage from '@/pages/admin/health-integrations/tiss/tiss-credential-form-page'
import TissCredentialsPage from '@/pages/admin/health-integrations/tiss/tiss-credentials-page'
import TissPage from '@/pages/admin/health-integrations/tiss/tiss-page'
import TissTransactionsPage from '@/pages/admin/health-integrations/tiss/tiss-transactions-page'
// Billing
import AuthorizationDetailPage from '@/pages/admin/billing/authorizations/authorization-detail-page'
import AuthorizationFormPage from '@/pages/admin/billing/authorizations/authorization-form-page'
import AuthorizationsPage from '@/pages/admin/billing/authorizations/authorizations-page'
import BatchDetailPage from '@/pages/admin/billing/batches/batch-detail-page'
import BatchFormPage from '@/pages/admin/billing/batches/batch-form-page'
import BatchesPage from '@/pages/admin/billing/batches/batches-page'
import BillingPage from '@/pages/admin/billing/billing-page'
import CoparticipationFormPage from '@/pages/admin/billing/coparticipation/coparticipation-form-page'
import CoparticipationPage from '@/pages/admin/billing/coparticipation/coparticipation-page'
import GlossDetailPage from '@/pages/admin/billing/glosses/gloss-detail-page'
import GlossFormPage from '@/pages/admin/billing/glosses/gloss-form-page'
import GlossesPage from '@/pages/admin/billing/glosses/glosses-page'
import GuideDetailPage from '@/pages/admin/billing/guides/guide-detail-page'
import GuideFormPage from '@/pages/admin/billing/guides/guide-form-page'
import GuidesPage from '@/pages/admin/billing/guides/guides-page'
import PriceTableDetailPage from '@/pages/admin/billing/price-tables/price-table-detail-page'
import PriceTableFormPage from '@/pages/admin/billing/price-tables/price-table-form-page'
import PriceTablesPage from '@/pages/admin/billing/price-tables/price-tables-page'
import ServicePaymentsPage from '@/pages/admin/billing/service-payments/service-payments-page'
// Stock
import StockBatchFormPage from '@/pages/admin/stock/batches/batch-form-page'
import StockBatchesPage from '@/pages/admin/stock/batches/batches-page'
import StockDashboardPage from '@/pages/admin/stock/dashboard/stock-dashboard-page'
import DispensationFormPage from '@/pages/admin/stock/dispensation/dispensation-form-page'
import DispensationPage from '@/pages/admin/stock/dispensation/dispensation-page'
import MedicationFormPage from '@/pages/admin/stock/medications/medication-form-page'
import MedicationsPage from '@/pages/admin/stock/medications/medications-page'
import SngpcPage from '@/pages/admin/stock/sngpc/sngpc-page'
import StorageUnitFormPage from '@/pages/admin/stock/temperature/storage-unit-form-page'
import TemperaturePage from '@/pages/admin/stock/temperature/temperature-page'
// Hospital
import AdmissionFormPage from '@/pages/admin/hospital/admissions/admission-form-page'
import AdmissionsPage from '@/pages/admin/hospital/admissions/admissions-page'
import BedFormPage from '@/pages/admin/hospital/beds/bed-form-page'
import BedsPage from '@/pages/admin/hospital/beds/beds-page'
import CleaningPage from '@/pages/admin/hospital/cleaning/cleaning-page'
import HospitalDischargeFormPage from '@/pages/admin/hospital/discharge/discharge-form-page'
import HospitalDischargePage from '@/pages/admin/hospital/discharge/discharge-page'
import FluidBalanceFormPage from '@/pages/admin/hospital/fluid-balance/fluid-balance-form-page'
import FluidBalancePage from '@/pages/admin/hospital/fluid-balance/fluid-balance-page'
import HospitalDashboardPage from '@/pages/admin/hospital/hospital-dashboard-page'
import HospitalPage from '@/pages/admin/hospital/hospital-page'
import NursingEvolutionFormPage from '@/pages/admin/hospital/nursing-evolution/nursing-evolution-form-page'
import NursingEvolutionPage from '@/pages/admin/hospital/nursing-evolution/nursing-evolution-page'
import HospitalPrescriptionFormPage from '@/pages/admin/hospital/prescriptions/prescription-form-page'
import HospitalPrescriptionsPage from '@/pages/admin/hospital/prescriptions/prescriptions-page'
import TransfersPage from '@/pages/admin/hospital/transfers/transfers-page'
import UnitFormPage from '@/pages/admin/hospital/units/unit-form-page'
import UnitsPage from '@/pages/admin/hospital/units/units-page'
import VitalSignsFormPage from '@/pages/admin/hospital/vital-signs/vital-signs-form-page'
import VitalSignsPage from '@/pages/admin/hospital/vital-signs/vital-signs-page'
// Financial
import BillingDetailPage from '@/pages/admin/financial/billings/billing-detail-page'
import BillingsFormPage from '@/pages/admin/financial/billings/billings-form-page'
import BillingsListPage from '@/pages/admin/financial/billings/billings-list-page'
import SaleSimulatorPage from '@/pages/admin/financial/sale-simulator/sale-simulator-page'
import CashRegisterPage from '@/pages/admin/financial/cash-register/cash-register-page'
import FinancialDashboardPage from '@/pages/admin/financial/dashboard/financial-dashboard-page'
import TerminalsPage from '@/pages/admin/financial/terminals/terminals-page'
import PaymentAccountPage from '@/pages/admin/financial/payment-account/payment-account-page'
import LedgerPage from '@/pages/admin/financial/ledger/ledger-page'
import OrphanPaymentsPage from '@/pages/admin/financial/orphan-payments/orphan-payments-page'
import LedgerDetailPage from '@/pages/admin/financial/ledger/ledger-detail-page'
import FinancialTransfersPage from '@/pages/admin/financial/transfers/transfers-page'
import FinancialTransferDetailPage from '@/pages/admin/financial/transfers/transfer-detail-page'
import FinancialTransferApprovalsPage from '@/pages/admin/financial/transfers/transfer-approvals-page'
import BillingApprovalsPage from '@/pages/admin/financial/billing-approvals/billing-approvals-page'
import ChartOfAccountsPage from '@/pages/admin/financial/chart-of-accounts/chart-of-accounts-page'
import JournalEntriesPage from '@/pages/admin/financial/accounting/journal-entries-page'
import AccountingDashboardPage from '@/pages/admin/financial/accounting/accounting-dashboard-page'
import JournalEntryDetailPage from '@/pages/admin/financial/accounting/journal-entry-detail-page'
import AccountingRulesPage from '@/pages/admin/financial/accounting-rules/accounting-rules-page'
import DREReportPage from '@/pages/admin/financial/accounting-reports/dre-report-page'
import BalanceteReportPage from '@/pages/admin/financial/accounting-reports/balancete-report-page'
import RazaoReportPage from '@/pages/admin/financial/accounting-reports/razao-report-page'
import FluxoCaixaReportPage from '@/pages/admin/financial/accounting-reports/fluxo-caixa-report-page'
import BalancoPatrimonialReportPage from '@/pages/admin/financial/accounting-reports/balanco-patrimonial-report-page'
import RequireAccountingOnboarding from '@/pages/admin/financial/accounting/components/require-accounting-onboarding'
import FinancialCategoriesPage from '@/pages/admin/financial/financial-categories/financial-categories-page'
import CostCentersPage from '@/pages/admin/financial/cost-centers/cost-centers-page'
import BankAccountsPage from '@/pages/admin/financial/bank-accounts/bank-accounts-page'
import BankAccountStatementPage from '@/pages/admin/financial/bank-accounts/bank-account-statement-page'
import FinancialSettingsPage from '@/pages/admin/financial/settings/financial-settings-page'
// HR
import HrEmployeesListPage from '@/pages/admin/hr/employees/hr-employees-list-page'
import HrEmployeeFormPage from '@/pages/admin/hr/employees/hr-employee-form-page'
import HrEmployeeDetailPage from '@/pages/admin/hr/employees/hr-employee-detail-page'
import PayrollRunsListPage from '@/pages/admin/hr/payroll/payroll-runs-list-page'
import PayrollRunDetailPage from '@/pages/admin/hr/payroll/payroll-run-detail-page'
import RubricsPage from '@/pages/admin/hr/rubrics/rubrics-page'
import PayrollTablesPage from '@/pages/admin/hr/tables/payroll-tables-page'
import VacationsPage from '@/pages/admin/hr/vacations/vacations-page'
import TimeTrackingPage from '@/pages/admin/hr/time-tracking/time-tracking-page'
import EsocialPage from '@/pages/admin/hr/esocial/esocial-page'
import HourBankPage from '@/pages/admin/hr/hour-bank/hour-bank-page'
// Marketing
import MarketingDashboardPage from '@/pages/admin/marketing/dashboard/marketing-dashboard-page'
import CampaignsListPage from '@/pages/admin/marketing/campaigns/campaigns-list-page'
import CampaignFormPage from '@/pages/admin/marketing/campaigns/campaign-form-page'
import CampaignDetailPage from '@/pages/admin/marketing/campaigns/campaign-detail-page'
import MetaIntegrationPage from '@/pages/admin/marketing/meta/meta-integration-page'
import GoogleAdsIntegrationPage from '@/pages/admin/marketing/google-ads/google-ads-integration-page'
import TikTokAdsIntegrationPage from '@/pages/admin/marketing/tiktok-ads/tiktok-ads-integration-page'
import MarketingEventsPage from '@/pages/admin/marketing/events/marketing-events-page'
import SiteBannersListPage from '@/pages/admin/marketing/site-banners/site-banners-list-page'
import SiteBannerFormPage from '@/pages/admin/marketing/site-banners/site-banner-form-page'
// Messaging (Mensageria)
import WhatsappTemplatesPage from '@/pages/admin/messaging/whatsapp-templates/whatsapp-templates-page'
import WhatsappTemplateFormPage from '@/pages/admin/messaging/whatsapp-templates/whatsapp-template-form-page'
import QuickMessagesPage from '@/pages/admin/messaging/quick-messages/quick-messages-page'
import QuickMessageFormPage from '@/pages/admin/messaging/quick-messages/quick-message-form-page'
import WhatsappAccountPage from '@/pages/admin/messaging/whatsapp-account/whatsapp-account-page'
import MessagingSettingsPage from '@/pages/admin/messaging/settings/messaging-settings-page'
import WhatsappBroadcastsPage from '@/pages/admin/messaging/whatsapp-broadcasts/whatsapp-broadcasts-page'
import WhatsappBroadcastFormPage from '@/pages/admin/messaging/whatsapp-broadcasts/whatsapp-broadcast-form-page'
import WhatsappBroadcastDetailPage from '@/pages/admin/messaging/whatsapp-broadcasts/whatsapp-broadcast-detail-page'
// Sales (Vendas)
import SalesConfigPage from '@/pages/admin/sales/config/sales-config-page'
import WalletsListPage from '@/pages/admin/sales/wallets/wallets-list-page'
import UnassignedClientsPage from '@/pages/admin/sales/wallets/unassigned-clients-page'
import PipelinesListPage from '@/pages/admin/sales/pipelines/pipelines-list-page'
import PipelineDetailPage from '@/pages/admin/sales/pipelines/pipeline-detail-page'
import LeadsListPage from '@/pages/admin/sales/leads/leads-list-page'
import SalesLeadDetailPage from '@/pages/admin/sales/leads/lead-detail-page'
import DealsListPage from '@/pages/admin/sales/deals/deals-list-page'
import DealDetailPage from '@/pages/admin/sales/deals/deal-detail-page'
import SLAsPage from '@/pages/admin/sales/slas/slas-page'
import FlowsPage from '@/pages/admin/sales/flows/flows-page'
import FlowEditorPage from '@/pages/admin/sales/flows/flow-editor-page'
import SalesDashboardPage from '@/pages/admin/sales/dashboard/sales-dashboard-page'
import GamificationPage from '@/pages/admin/sales/gamification/gamification-page'
// Administrative
import ContractPage from '@/pages/admin/administrative/contracts/contract'
import ContractsListPage from '@/pages/admin/administrative/contracts/contracts-list'
// Revendas
import ResalesListPage from '@/pages/admin/administrative/resales/resales-list-page'
import ResaleFormPage from '@/pages/admin/administrative/resales/resale-form-page'
// Sign
import SignDocumentDetailPage from '@/pages/admin/administrative/sign/sign-document-detail'
import SignDocumentFormPage from '@/pages/admin/administrative/sign/sign-document-form'
import SignDocumentsListPage from '@/pages/admin/administrative/sign/sign-documents-list'
// Inbox
import InboxAccountsPage from '@/pages/admin/administrative/inbox/inbox-accounts-page'
import InboxPage from '@/pages/admin/administrative/inbox/inbox-page'
import InboxTemplatesPage from '@/pages/admin/administrative/inbox/inbox-templates-page'
// Fiscal
import FiscalNoteDetailPage from '@/pages/admin/fiscal/fiscal-note-detail-page'
import FiscalNotesPage from '@/pages/admin/fiscal/fiscal-notes-page'
import FiscalSettingsPage from '@/pages/admin/fiscal/fiscal-settings-page'
import NfeFormPage from '@/pages/admin/fiscal/nfe-form-page'
import NfseFormPage from '@/pages/admin/fiscal/nfse-form-page'
// Security
import PermissionsPage from '@/pages/admin/core/security/permissions-page'
import EventsPage from '@/pages/admin/security/events/events-page'
import RoleDetailPage from '@/pages/admin/core/security/role-detail-page'
import RoleFormPage from '@/pages/admin/core/security/role-form-page'
// Shared
import RegistrationGuard from '@/components/registration-guard/registration-guard'
import SubscriptionAlert from '@/components/subscription-alert'
import UrgentAlertsBar from '@/components/urgent-alerts-bar'

/**
 * Agendamento com `key` por registro.
 *
 * `/atendimento/scheduling` e `/atendimento/scheduling/:id` renderizam o MESMO
 * elemento: sem uma key que mude, o React reaproveita a instância entre as duas
 * rotas e nenhum `useState` é reiniciado — só os params mudam. O sintoma é o
 * formulário de um atendimento novo abrindo com o valor, o parceiro e o item do
 * catálogo do registro que se acabou de editar (o caminho do "Adicionar outro"
 * saindo da edição, que troca `/:id` por `?clientId=...`).
 */
const SchedulingFormRoute = () => {
    const { id } = useParams<{ id: string }>()
    return <SchedulingFormPage key={id ?? 'new'} />
}

/**
 * Recursos que migraram do módulo `medical` para `bookings` (núcleo agendável,
 * agnóstico de segmento). Usados só para montar os redirects de compatibilidade.
 */
const LEGACY_MEDICAL_ROUTES = [
    'consultations',
    'triage',
    'teleconsultations',
    'exams',
    'orders',
    'packages',
    'reports',
    'settings',
    'cash-closing',
] as const

/**
 * Redireciona `/medical/<recurso>/...` para `/bookings/<recurso>/...` preservando
 * o restante do caminho (ids, sub-rotas) e a query string.
 *
 * `<Navigate to="/bookings/exams">` não serve: perderia o `/:id` do link salvo, e
 * o usuário cairia na listagem em vez do registro que ele abriu.
 */
const LegacyMedicalRedirect = () => {
    const location = useLocation()
    const target =
        location.pathname.replace(/^\/medical\//, '/bookings/') +
        location.search +
        location.hash
    return <Navigate to={target} replace />
}

/**
 * `/fiscal/certificates` -> `/registrations/certificates`.
 *
 * A tela é o certificado A1 do profissional, não o certificado de NF-e; ficava sob
 * `/fiscal` por engano de nomenclatura. Sem sub-rotas a preservar, mas o link pode
 * estar salvo ou vir de notificação antiga.
 */
const LegacyFiscalCertificatesRedirect = () => (
    <Navigate to="/registrations/certificates" replace />
)

/** `/registrations/medical-supplies/12` -> `/registrations/supplies/12`. */
const LegacySuppliesRedirect = () => {
    const location = useLocation()
    const target =
        location.pathname.replace(
            /^\/registrations\/medical-supplies/,
            '/registrations/supplies'
        ) +
        location.search +
        location.hash
    return <Navigate to={target} replace />
}

const AdminRoutes = () => {
    return (
        <RegistrationGuard>
            <SubscriptionAlert />
            <UrgentAlertsBar />
            <Routes>
                <Route path="/" element={<AdminLayout />}>
                    <Route index element={<WelcomePage />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route
                        path="/core/search"
                        element={<SearchResultsPage />}
                    />
                    {/* Unidades da Organizacao */}
                    <Route
                        path="/person/companies"
                        element={<CompanyUnitsPage />}
                    />
                    <Route
                        path="/person/companies/new"
                        element={<CompanyUnitFormPage />}
                    />
                    <Route
                        path="/person/companies/:id"
                        element={<CompanyUnitFormPage />}
                    />
                    {/* Relatórios */}
                    <Route path="/core/reports" element={<DataReportsPage />} />
                    <Route
                        path="/core/reports/automations"
                        element={<ReportAutomationsPage />}
                    />
                    <Route
                        path="/atendimento/chats"
                        element={<AtendimentosPage />}
                    />
                    <Route
                        path="/atendimento/chats/:id"
                        element={<AtendimentosPage />}
                    />
                    {/* O cadastro de produto virou o do catálogo (`category = PRODUCT`)
                        na unificação: as três rotas de /commerce/products saíram e o menu
                        aponta para a listagem do catálogo já filtrada. */}
                    <Route
                        path="/commerce/products/*"
                        element={
                            <Navigate
                                to="/registrations/catalog?category=PRODUCT"
                                replace
                            />
                        }
                    />
                    {/* Venda de balcão: mercadoria vendida no painel, sem a loja. Fica em
                        /commerce porque é venda, não agendamento — o pedido nasce com
                        `origin: COUNTER`. */}
                    <Route
                        path="/commerce/counter-sale"
                        element={<CounterSalePage />}
                    />
                    <Route
                        path="/commerce/promos"
                        element={<PromosListPage />}
                    />
                    <Route
                        path="/commerce/promos/new"
                        element={<PromosFormPage />}
                    />
                    <Route
                        path="/commerce/promos/edit/:id"
                        element={<PromosFormPage />}
                    />
                    <Route
                        path="/commerce/coupons"
                        element={<CouponsListPage />}
                    />
                    <Route
                        path="/commerce/coupons/new"
                        element={<CouponsFormPage />}
                    />
                    <Route
                        path="/commerce/coupons/edit/:id"
                        element={<CouponsFormPage />}
                    />
                    <Route
                        path="/atendimento/sectors"
                        element={<DepartmentsListPage />}
                    />
                    <Route
                        path="/atendimento/sectors/new"
                        element={<DepartmentsFormPage />}
                    />
                    <Route
                        path="/atendimento/sectors/edit/:id"
                        element={<DepartmentsFormPage />}
                    />
                    <Route
                        path="/atendimento/agents"
                        element={<AttendantsListPage />}
                    />
                    <Route
                        path="/atendimento/simulator"
                        element={<ConversationSimulatorPage />}
                    />
                    <Route
                        path="/atendimento/agents/new"
                        element={<AttendantsFormPage />}
                    />
                    <Route
                        path="/atendimento/agents/edit/:id"
                        element={<AttendantsFormPage />}
                    />
                    <Route
                        path="/security/users"
                        element={<EmployeesListPage />}
                    />
                    <Route
                        path="/security/users/new"
                        element={<EmployeesFormPage />}
                    />
                    <Route
                        path="/security/users/edit/:id"
                        element={<EmployeesFormPage />}
                    />
                    {/* Redirects das rotas antigas */}
                    <Route
                        path="/hr/employees"
                        element={<Navigate to="/security/users" replace />}
                    />
                    <Route
                        path="/hr/employees/new"
                        element={<Navigate to="/security/users/new" replace />}
                    />
                    <Route
                        path="/hr/employees/edit/:id"
                        element={<Navigate to="/security/users" replace />}
                    />
                    <Route
                        path="/person/partners"
                        element={<PartnersListPage />}
                    />
                    <Route
                        path="/person/partners/new"
                        element={<PartnersFormPage />}
                    />
                    <Route
                        path="/person/partners/edit/:id"
                        element={<PartnersFormPage />}
                    />
                    <Route
                        path="/person/partners/:id"
                        element={<PartnerDetailPage />}
                    />
                    <Route
                        path="/person/suppliers"
                        element={<SuppliersPage />}
                    />
                    <Route
                        path="/person/suppliers/new"
                        element={<SupplierFormPage />}
                    />
                    <Route
                        path="/person/suppliers/edit/:id"
                        element={<SupplierFormPage />}
                    />
                    <Route
                        path="/person/suppliers/:id"
                        element={<SupplierDetailPage />}
                    />
                    <Route path="/account" element={<AccountPage />} />
                    <Route path="/system-store" element={<SystemStorePage />} />
                    <Route path="/support" element={<SupportPage />} />
                    <Route
                        path="/storage/files"
                        element={<StorageFilesPage />}
                    />
                    <Route
                        path="/storage/shares"
                        element={<StorageSharesPage />}
                    />
                    <Route
                        path="/storage/settings"
                        element={<StorageSettingsPage />}
                    />
                    {/* Loja Online */}
                    <Route
                        path="/commerce/stores"
                        element={<StoresListPage />}
                    />
                    <Route
                        path="/commerce/stores/new"
                        element={<StoreSettingsPage />}
                    />
                    <Route
                        path="/commerce/stores/edit/:id"
                        element={<StoreSettingsPage />}
                    />
                    <Route
                        path="/commerce/themes"
                        element={<StoreThemesPage />}
                    />
                    <Route
                        path="/commerce/themes/:storeId"
                        element={<StoreThemePage />}
                    />
                    <Route
                        path="/commerce/newsletter"
                        element={<StoreNewsletterPage />}
                    />
                    <Route
                        path="/commerce/stores/widgets"
                        element={<WidgetsListPage />}
                    />
                    <Route
                        path="/commerce/stores/widgets/new"
                        element={<WidgetFormPage />}
                    />
                    <Route
                        path="/commerce/stores/widgets/edit/:id"
                        element={<WidgetFormPage />}
                    />
                    <Route
                        path="/commerce/stores/:storeId/shipping"
                        element={<ShippingConfigPage />}
                    />
                    <Route path="/person/clients" element={<ClientsPage />} />
                    <Route
                        path="/person/clients/new"
                        element={<ClientFormPage />}
                    />
                    <Route
                        path="/person/clients/edit/:id"
                        element={<ClientFormPage />}
                    />
                    <Route
                        path="/person/clients/:id"
                        element={<ClientDetailPage />}
                    />
                    {/* Prontuario (Medical Record) Routes */}
                    <Route
                        path="/person/clients/:clientId/prontuario"
                        element={<ProntuarioLayout />}
                    >
                        <Route index element={<ProntuarioResumoPage />} />
                        <Route path="alergias" element={<AlergiasPage />} />
                        <Route
                            path="antecedentes"
                            element={<AntecedentesPage />}
                        />
                        <Route path="anamneses" element={<AnamnesesPage />} />
                        <Route
                            path="anamneses/new"
                            element={<AnamneseFormPage />}
                        />
                        <Route
                            path="anamneses/:anamneseId"
                            element={<AnamneseDetailPage />}
                        />
                        <Route
                            path="anamneses/:anamneseId/editar"
                            element={<AnamneseFormPage />}
                        />
                        <Route path="evolucoes" element={<EvolucoesPage />} />
                        <Route
                            path="evolucoes/new"
                            element={<EvolucaoFormPage />}
                        />
                        <Route
                            path="evolucoes/:evolucaoId"
                            element={<EvolucaoDetailPage />}
                        />
                        <Route
                            path="evolucoes/:evolucaoId/editar"
                            element={<EvolucaoFormPage />}
                        />
                        <Route path="consultas" element={<ConsultasPage />} />
                        <Route path="exames" element={<ExamesPage />} />
                        <Route
                            path="procedimentos"
                            element={<ProcedimentosPage />}
                        />
                        <Route
                            path="diagnosticos"
                            element={<DiagnosticosPage />}
                        />
                        <Route
                            path="encaminhamentos"
                            element={<EncaminhamentosPage />}
                        />
                        <Route
                            path="receituario"
                            element={<ReceituarioPage />}
                        />
                        <Route path="atestados" element={<AtestadosPage />} />
                        <Route path="convenios" element={<ConveniosPage />} />
                        <Route
                            path="consentimentos"
                            element={<ConsentimentosPage />}
                        />
                        <Route
                            path="health-map"
                            element={<HealthMapPage />}
                        />
                        <Route
                            path="anotacoes"
                            element={<AnotacoesPage />}
                        />
                        <Route path="timeline" element={<TimelinePage />} />
                    </Route>
                    <Route
                        path="/integrations"
                        element={<IntegrationsPage />}
                    />
                    <Route
                        path="/integrations/new"
                        element={<IntegrationFormPage />}
                    />
                    <Route
                        path="/integrations/edit/:id"
                        element={<IntegrationFormPage />}
                    />
                    <Route
                        path="/atendimento/agenda/:agendaId/settings"
                        element={<AgendaSettingsPage />}
                    />
                    <Route
                        path="/atendimento/agenda"
                        element={<AgendaPage />}
                    />
                    <Route
                        path="/person/professionals"
                        element={<ProfessionalsPage />}
                    />
                    <Route
                        path="/person/professionals/new"
                        element={<ProfessionalFormPage />}
                    />
                    <Route
                        path="/person/professionals/edit/:id"
                        element={<ProfessionalFormPage />}
                    />
                    <Route
                        path="/person/professionals/:id"
                        element={<ProfessionalDetailPage />}
                    />
                    <Route path="/bookings/triage" element={<TriagesPage />} />
                    <Route
                        path="/bookings/triage/new"
                        element={<TriageFormPage />}
                    />
                    <Route
                        path="/bookings/triage/edit/:id"
                        element={<TriageFormPage />}
                    />
                    <Route
                        path="/bookings/triage/:id"
                        element={<TriageDetailPage />}
                    />
                    <Route path="/bookings/exams" element={<ExamsPage />} />
                    <Route
                        path="/bookings/presence"
                        element={<PresencePage />}
                    />
                    <Route
                        path="/bookings/packages"
                        element={<PackagesPage />}
                    />
                    <Route
                        path="/bookings/exams/:id"
                        element={<ExamDetailPage />}
                    />
                    <Route
                        path="/bookings/exams/:id/results"
                        element={<ExamResultsPage />}
                    />
                    <Route
                        path="/medical/prescriptions"
                        element={<PrescriptionsPage />}
                    />
                    <Route
                        path="/medical/prescriptions/new"
                        element={<PrescriptionFormPage />}
                    />
                    <Route
                        path="/medical/prescriptions/edit/:id"
                        element={<PrescriptionFormPage />}
                    />
                    <Route
                        path="/medical/prescriptions/:id"
                        element={<PrescriptionDetailPage />}
                    />
                    <Route
                        path="/bookings/orders"
                        element={<OrdersPage />}
                    />
                    <Route
                        path="/bookings/orders/:id"
                        element={<OrderDetailPage />}
                    />
                    {/* Fechamento de caixa do próprio operador (não é relatório
                        do sistema: só o que o usuário logado registrou). */}
                    <Route
                        path="/bookings/cash-closing"
                        element={<CashClosingPage />}
                    />
                    <Route path="/bookings/reports" element={<ReportsPage />} />
                    <Route
                        path="/bookings/reports/new"
                        element={<ReportFormPage />}
                    />
                    <Route
                        path="/bookings/reports/edit/:id"
                        element={<ReportFormPage />}
                    />
                    <Route
                        path="/bookings/reports/:id"
                        element={<ReportDetailPage />}
                    />
                    <Route
                        path="/bookings/settings"
                        element={<MedicalSettingsPage />}
                    />
                    <Route
                        path="/medical/health-map/settings"
                        element={<HealthMapSettingsPage />}
                    />
                    <Route
                        path="/atendimento/scheduling"
                        element={<SchedulingFormRoute />}
                    />
                    <Route
                        path="/atendimento/scheduling/:id"
                        element={<SchedulingFormRoute />}
                    />
                    <Route
                        path="/bookings/consultations"
                        element={<ConsultationsPage />}
                    />
                    <Route
                        path="/bookings/consultations/:id"
                        element={<ConsultationDetailPage />}
                    />
                    <Route
                        path="/bookings/consultations/:id/room"
                        element={<ConsultationRoomPage />}
                    />
                    {/* Teleconsultas */}
                    <Route
                        path="/bookings/teleconsultations"
                        element={<TeleconsultationsPage />}
                    />
                    <Route
                        path="/bookings/teleconsultations/:id"
                        element={<TeleconsultationDetailPage />}
                    />
                    <Route
                        path="/bookings/teleconsultations/:id/room"
                        element={<TeleconsultationRoomPage />}
                    />
                    {/* Cadastros Gerais */}
                    <Route
                        path="/registrations/letterheads"
                        element={<LetterheadsListPage />}
                    />
                    <Route
                        path="/registrations/letterheads/new"
                        element={<LetterheadsFormPage />}
                    />
                    <Route
                        path="/registrations/letterheads/:id"
                        element={<LetterheadsFormPage />}
                    />
                    <Route
                        path="/registrations/hospitals"
                        element={<HospitalsPage />}
                    />
                    <Route
                        path="/registrations/hospitals/new"
                        element={<HospitalFormPage />}
                    />
                    <Route
                        path="/registrations/hospitals/edit/:id"
                        element={<HospitalFormPage />}
                    />
                    <Route
                        path="/registrations/hospitals/:id"
                        element={<HospitalDetailPage />}
                    />
                    <Route
                        path="/registrations/catalog"
                        element={<CatalogListPage />}
                    />
                    <Route
                        path="/registrations/catalog/new"
                        element={<CatalogFormPage />}
                    />
                    <Route
                        path="/registrations/catalog/variations-pricing"
                        element={<VariationsPricingPage />}
                    />
                    {/*
                      Estoque dos PRODUTOS do catálogo. Vem ANTES de
                      `/registrations/catalog/:id` de propósito: a rota com parâmetro
                      casaria com a palavra "stock" e abriria o formulário de um item
                      inexistente.
                    */}
                    <Route
                        path="/registrations/catalog/stock"
                        element={<CatalogStockPage />}
                    />
                    <Route
                        path="/registrations/catalog/types"
                        element={<CatalogTypeListPage />}
                    />
                    <Route
                        path="/registrations/catalog/types/new"
                        element={<CatalogTypeFormPage />}
                    />
                    <Route
                        path="/registrations/catalog/types/:id"
                        element={<CatalogTypeFormPage />}
                    />
                    <Route
                        path="/registrations/catalog/:id/details"
                        element={<CatalogDetailPage />}
                    />
                    <Route
                        path="/registrations/catalog/:id"
                        element={<CatalogFormPage />}
                    />
                    <Route
                        path="/registrations/specialties"
                        element={<SpecialtyListPage />}
                    />
                    <Route
                        path="/registrations/specialties/new"
                        element={<SpecialtyFormPage />}
                    />
                    <Route
                        path="/registrations/specialties/:id"
                        element={<SpecialtyFormPage />}
                    />
                    <Route
                        path="/registrations/rooms"
                        element={<RoomListPage />}
                    />
                    <Route
                        path="/registrations/rooms/new"
                        element={<RoomFormPage />}
                    />
                    <Route
                        path="/registrations/rooms/:id"
                        element={<RoomFormPage />}
                    />
                    <Route
                        path="/registrations/product-categories"
                        element={<ProductCategoryListPage />}
                    />
                    <Route
                        path="/registrations/product-categories/new"
                        element={<ProductCategoryFormPage />}
                    />
                    <Route
                        path="/registrations/product-categories/:id"
                        element={<ProductCategoryFormPage />}
                    />
                    <Route
                        path="/registrations/convenios"
                        element={<HealthPlanListPage />}
                    />
                    <Route
                        path="/registrations/convenios/new"
                        element={<HealthPlanFormPage />}
                    />
                    <Route
                        path="/registrations/convenios/:id"
                        element={<HealthPlanFormPage />}
                    />
                    {/* Medical Supplies */}
                    <Route
                        path="/registrations/supplies"
                        element={<MedicalSuppliesListPage />}
                    />
                    <Route
                        path="/registrations/supplies/new"
                        element={<MedicalSuppliesFormPage />}
                    />
                    <Route
                        path="/registrations/supplies/:id"
                        element={<MedicalSuppliesFormPage />}
                    />
                    {/* Medical Services */}
                    <Route
                        path="/registrations/medical-services"
                        element={<MedicalServicesListPage />}
                    />
                    <Route
                        path="/registrations/medical-services/new"
                        element={<MedicalServicesFormPage />}
                    />
                    <Route
                        path="/registrations/medical-services/:id"
                        element={<MedicalServicesFormPage />}
                    />
                    {/* Establishments */}
                    <Route
                        path="/registrations/establishments"
                        element={<EstablishmentsListPage />}
                    />
                    <Route
                        path="/registrations/establishments/new"
                        element={<EstablishmentsFormPage />}
                    />
                    <Route
                        path="/registrations/establishments/:id"
                        element={<EstablishmentsFormPage />}
                    />
                    {/* Supplier Types */}
                    <Route
                        path="/registrations/supplier-types"
                        element={<SupplierTypesListPage />}
                    />
                    <Route
                        path="/registrations/supplier-types/new"
                        element={<SupplierTypesFormPage />}
                    />
                    <Route
                        path="/registrations/supplier-types/:id"
                        element={<SupplierTypesFormPage />}
                    />
                    {/* Health Integrations Routes */}
                    <Route
                        path="/health-integrations"
                        element={<HealthIntegrationsPage />}
                    />
                    {/* Lab Integration */}
                    <Route
                        path="/health-integrations/lab"
                        element={<LabIntegrationsPage />}
                    />
                    <Route
                        path="/health-integrations/lab/new"
                        element={<LabIntegrationFormPage />}
                    />
                    <Route
                        path="/health-integrations/lab/edit/:id"
                        element={<LabIntegrationFormPage />}
                    />
                    <Route
                        path="/health-integrations/lab/messages"
                        element={<LabMessagesPage />}
                    />
                    {/* TISS */}
                    <Route
                        path="/health-integrations/tiss"
                        element={<TissPage />}
                    />
                    <Route
                        path="/health-integrations/tiss/new"
                        element={<TissFormPage />}
                    />
                    <Route
                        path="/health-integrations/tiss/edit/:id"
                        element={<TissFormPage />}
                    />
                    <Route
                        path="/health-integrations/tiss/credentials"
                        element={<TissCredentialsPage />}
                    />
                    <Route
                        path="/health-integrations/tiss/credentials/new"
                        element={<TissCredentialFormPage />}
                    />
                    <Route
                        path="/health-integrations/tiss/credentials/edit/:id"
                        element={<TissCredentialFormPage />}
                    />
                    <Route
                        path="/health-integrations/tiss/transactions"
                        element={<TissTransactionsPage />}
                    />
                    {/* Pharmacy */}
                    <Route
                        path="/health-integrations/pharmacy"
                        element={<PharmacyPage />}
                    />
                    <Route
                        path="/health-integrations/pharmacy/new"
                        element={<PharmacyFormPage />}
                    />
                    <Route
                        path="/health-integrations/pharmacy/edit/:id"
                        element={<PharmacyFormPage />}
                    />
                    <Route
                        path="/health-integrations/pharmacy/receitas"
                        element={<ElectronicPrescriptionsPage />}
                    />
                    {/* PACS */}
                    <Route
                        path="/health-integrations/pacs"
                        element={<PacsPage />}
                    />
                    <Route
                        path="/health-integrations/pacs/new"
                        element={<PacsFormPage />}
                    />
                    <Route
                        path="/health-integrations/pacs/edit/:id"
                        element={<PacsFormPage />}
                    />
                    <Route
                        path="/health-integrations/pacs/studies"
                        element={<DicomStudiesPage />}
                    />
                    {/* RNDS */}
                    <Route
                        path="/health-integrations/rnds"
                        element={<RndsPage />}
                    />
                    <Route
                        path="/health-integrations/rnds/new"
                        element={<RndsFormPage />}
                    />
                    <Route
                        path="/health-integrations/rnds/edit/:id"
                        element={<RndsFormPage />}
                    />
                    <Route
                        path="/health-integrations/rnds/transactions"
                        element={<RndsTransactionsPage />}
                    />
                    {/* Billing Routes */}
                    <Route path="/billing" element={<BillingPage />} />
                    {/* Price Tables */}
                    <Route
                        path="/billing/price-tables"
                        element={<PriceTablesPage />}
                    />
                    <Route
                        path="/billing/price-tables/new"
                        element={<PriceTableFormPage />}
                    />
                    <Route
                        path="/billing/price-tables/:id"
                        element={<PriceTableDetailPage />}
                    />
                    <Route
                        path="/billing/price-tables/:id/edit"
                        element={<PriceTableFormPage />}
                    />
                    {/* Guides */}
                    <Route path="/billing/guides" element={<GuidesPage />} />
                    <Route
                        path="/billing/guides/new"
                        element={<GuideFormPage />}
                    />
                    <Route
                        path="/billing/guides/:id"
                        element={<GuideDetailPage />}
                    />
                    <Route
                        path="/billing/guides/:id/edit"
                        element={<GuideFormPage />}
                    />
                    {/* Glosses */}
                    <Route path="/billing/glosses" element={<GlossesPage />} />
                    <Route
                        path="/billing/glosses/new"
                        element={<GlossFormPage />}
                    />
                    <Route
                        path="/billing/glosses/:id"
                        element={<GlossDetailPage />}
                    />
                    <Route
                        path="/billing/glosses/:id/edit"
                        element={<GlossFormPage />}
                    />
                    {/* Authorizations */}
                    <Route
                        path="/billing/authorizations"
                        element={<AuthorizationsPage />}
                    />
                    <Route
                        path="/billing/authorizations/new"
                        element={<AuthorizationFormPage />}
                    />
                    <Route
                        path="/billing/authorizations/:id"
                        element={<AuthorizationDetailPage />}
                    />
                    <Route
                        path="/billing/authorizations/:id/edit"
                        element={<AuthorizationFormPage />}
                    />
                    {/* Batches */}
                    <Route path="/billing/batches" element={<BatchesPage />} />
                    <Route
                        path="/billing/batches/new"
                        element={<BatchFormPage />}
                    />
                    <Route
                        path="/billing/batches/:id"
                        element={<BatchDetailPage />}
                    />
                    <Route
                        path="/billing/batches/:id/edit"
                        element={<BatchFormPage />}
                    />
                    {/* Service Payments */}
                    <Route
                        path="/billing/payments"
                        element={<ServicePaymentsPage />}
                    />
                    {/* Coparticipation */}
                    <Route
                        path="/billing/coparticipation"
                        element={<CoparticipationPage />}
                    />
                    <Route
                        path="/billing/coparticipation/new"
                        element={<CoparticipationFormPage />}
                    />
                    <Route
                        path="/billing/coparticipation/:id/edit"
                        element={<CoparticipationFormPage />}
                    />
                    {/* Stock Routes */}
                    <Route path="/stock" element={<StockDashboardPage />} />
                    {/* Medications */}
                    <Route
                        path="/stock/medications"
                        element={<MedicationsPage />}
                    />
                    <Route
                        path="/stock/medications/new"
                        element={<MedicationFormPage />}
                    />
                    <Route
                        path="/stock/medications/:id"
                        element={<MedicationFormPage />}
                    />
                    <Route
                        path="/stock/medications/:id/edit"
                        element={<MedicationFormPage />}
                    />
                    {/* Batches */}
                    <Route
                        path="/stock/batches"
                        element={<StockBatchesPage />}
                    />
                    <Route
                        path="/stock/batches/new"
                        element={<StockBatchFormPage />}
                    />
                    <Route
                        path="/stock/batches/:id"
                        element={<StockBatchFormPage />}
                    />
                    <Route
                        path="/stock/batches/:id/edit"
                        element={<StockBatchFormPage />}
                    />
                    {/* Temperature */}
                    <Route
                        path="/stock/temperature"
                        element={<TemperaturePage />}
                    />
                    <Route
                        path="/stock/temperature/unidades/new"
                        element={<StorageUnitFormPage />}
                    />
                    <Route
                        path="/stock/temperature/unidades/:id"
                        element={<StorageUnitFormPage />}
                    />
                    {/* SNGPC */}
                    <Route path="/stock/sngpc" element={<SngpcPage />} />
                    {/* Dispensation */}
                    <Route
                        path="/stock/dispensation"
                        element={<DispensationPage />}
                    />
                    <Route
                        path="/stock/dispensation/new"
                        element={<DispensationFormPage />}
                    />
                    <Route
                        path="/stock/dispensation/:id"
                        element={<DispensationFormPage />}
                    />
                    {/* Hospital Routes */}
                    <Route path="/hospital" element={<HospitalPage />} />
                    <Route
                        path="/hospital/dashboard"
                        element={<HospitalDashboardPage />}
                    />
                    {/* Hospital Units */}
                    <Route path="/hospital/unidades" element={<UnitsPage />} />
                    <Route
                        path="/hospital/unidades/new"
                        element={<UnitFormPage />}
                    />
                    <Route
                        path="/hospital/unidades/:id"
                        element={<UnitFormPage />}
                    />
                    <Route
                        path="/hospital/unidades/:id/edit"
                        element={<UnitFormPage />}
                    />
                    {/* Hospital Beds */}
                    <Route path="/hospital/beds" element={<BedsPage />} />
                    <Route
                        path="/hospital/beds/new"
                        element={<BedFormPage />}
                    />
                    <Route
                        path="/hospital/beds/:id"
                        element={<BedFormPage />}
                    />
                    <Route
                        path="/hospital/beds/:id/edit"
                        element={<BedFormPage />}
                    />
                    {/* Hospital Admissions */}
                    <Route
                        path="/hospital/admissions"
                        element={<AdmissionsPage />}
                    />
                    <Route
                        path="/hospital/admissions/new"
                        element={<AdmissionFormPage />}
                    />
                    <Route
                        path="/hospital/admissions/:id"
                        element={<AdmissionFormPage />}
                    />
                    <Route
                        path="/hospital/admissions/:id/edit"
                        element={<AdmissionFormPage />}
                    />
                    {/* Hospital Cleaning */}
                    <Route
                        path="/hospital/cleaning"
                        element={<CleaningPage />}
                    />
                    {/* Hospital Transfers */}
                    <Route
                        path="/hospital/transfers"
                        element={<TransfersPage />}
                    />
                    {/* Hospital Vital Signs */}
                    <Route
                        path="/hospital/vital-signs"
                        element={<VitalSignsPage />}
                    />
                    <Route
                        path="/hospital/vital-signs/new"
                        element={<VitalSignsFormPage />}
                    />
                    <Route
                        path="/hospital/vital-signs/:id"
                        element={<VitalSignsFormPage />}
                    />
                    {/* Hospital Fluid Balance */}
                    <Route
                        path="/hospital/fluid-balance"
                        element={<FluidBalancePage />}
                    />
                    <Route
                        path="/hospital/fluid-balance/new"
                        element={<FluidBalanceFormPage />}
                    />
                    <Route
                        path="/hospital/fluid-balance/:id"
                        element={<FluidBalanceFormPage />}
                    />
                    {/* Hospital Nursing Evolution */}
                    <Route
                        path="/hospital/evolucoes"
                        element={<NursingEvolutionPage />}
                    />
                    <Route
                        path="/hospital/evolucoes/new"
                        element={<NursingEvolutionFormPage />}
                    />
                    <Route
                        path="/hospital/evolucoes/:id"
                        element={<NursingEvolutionFormPage />}
                    />
                    {/* Hospital Prescriptions */}
                    <Route
                        path="/hospital/prescricoes"
                        element={<HospitalPrescriptionsPage />}
                    />
                    <Route
                        path="/hospital/prescricoes/new"
                        element={<HospitalPrescriptionFormPage />}
                    />
                    <Route
                        path="/hospital/prescricoes/:id"
                        element={<HospitalPrescriptionFormPage />}
                    />
                    {/* Hospital Discharge */}
                    <Route
                        path="/hospital/discharges"
                        element={<HospitalDischargePage />}
                    />
                    <Route
                        path="/hospital/discharges/new"
                        element={<HospitalDischargeFormPage />}
                    />
                    <Route
                        path="/hospital/discharges/:id"
                        element={<HospitalDischargeFormPage />}
                    />
                    {/*
                        Certificado A1 do profissional. Saiu de /fiscal/certificates:
                        a URL sugeria certificado de NF-e, e a tela nunca teve nada a
                        ver com emissão fiscal. Redirect do caminho antigo mais abaixo.
                    */}
                    <Route
                        path="/registrations/certificates"
                        element={<CertificatesPage />}
                    />
                    <Route
                        path="/registrations/templates"
                        element={<TemplatesPage />}
                    />
                    {/* Financial */}
                    <Route
                        path="/financial/dashboard"
                        element={<FinancialDashboardPage />}
                    />
                    <Route
                        path="/financial/billings"
                        element={<BillingsListPage />}
                    />
                    <Route
                        path="/financial/billings/new"
                        element={<BillingsFormPage />}
                    />
                    <Route
                        path="/financial/billings/:id"
                        element={<BillingDetailPage />}
                    />
                    <Route
                        path="/financial/billings/:id/edit"
                        element={<BillingsFormPage />}
                    />
                    <Route
                        path="/financial/sale-simulator"
                        element={<SaleSimulatorPage />}
                    />
                    <Route
                        path="/financial/cash-register"
                        element={<CashRegisterPage />}
                    />
                    <Route
                        path="/financial/terminals"
                        element={<TerminalsPage />}
                    />
                    <Route
                        path="/financial/digital-account"
                        element={<PaymentAccountPage />}
                    />
                    <Route
                        path="/financial/statement"
                        element={<LedgerPage />}
                    />
                    <Route
                        path="/financial/statement/:id"
                        element={<LedgerDetailPage />}
                    />
                    <Route
                        path="/financial/orphan-payments"
                        element={<OrphanPaymentsPage />}
                    />
                    <Route
                        path="/financial/transfers"
                        element={<FinancialTransfersPage />}
                    />
                    <Route
                        path="/financial/transfers/:id"
                        element={<FinancialTransferDetailPage />}
                    />
                    <Route
                        path="/financial/transfers-approvals"
                        element={<FinancialTransferApprovalsPage />}
                    />
                    <Route
                        path="/financial/bills-approvals"
                        element={<BillingApprovalsPage />}
                    />
                    <Route
                        path="/financial/chart-of-accounts"
                        element={<ChartOfAccountsPage />}
                    />
                    <Route
                        path="/financial/journal-entries"
                        element={
                            <RequireAccountingOnboarding>
                                <JournalEntriesPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/journal-entries/:id"
                        element={
                            <RequireAccountingOnboarding>
                                <JournalEntryDetailPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/accounting"
                        element={<AccountingDashboardPage />}
                    />
                    <Route
                        path="/financial/accounting-rules"
                        element={
                            <RequireAccountingOnboarding>
                                <AccountingRulesPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/relatorios/dre"
                        element={
                            <RequireAccountingOnboarding>
                                <DREReportPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/relatorios/balancete"
                        element={
                            <RequireAccountingOnboarding>
                                <BalanceteReportPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/relatorios/razao/:accountId?"
                        element={
                            <RequireAccountingOnboarding>
                                <RazaoReportPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/relatorios/cash-flow"
                        element={
                            <RequireAccountingOnboarding>
                                <FluxoCaixaReportPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/relatorios/balanco-patrimonial"
                        element={
                            <RequireAccountingOnboarding>
                                <BalancoPatrimonialReportPage />
                            </RequireAccountingOnboarding>
                        }
                    />
                    <Route
                        path="/financial/financial-categories"
                        element={<FinancialCategoriesPage />}
                    />
                    <Route
                        path="/financial/cost-centers"
                        element={<CostCentersPage />}
                    />
                    <Route
                        path="/financial/bank-accounts"
                        element={<BankAccountsPage />}
                    />
                    <Route
                        path="/financial/bank-accounts/:id/statement"
                        element={<BankAccountStatementPage />}
                    />
                    <Route
                        path="/financial/settings"
                        element={<FinancialSettingsPage />}
                    />

                    {/* RH */}
                    <Route
                        path="/hr/funcionarios"
                        element={<HrEmployeesListPage />}
                    />
                    <Route
                        path="/hr/funcionarios/new"
                        element={<HrEmployeeFormPage />}
                    />
                    <Route
                        path="/hr/funcionarios/:id"
                        element={<HrEmployeeDetailPage />}
                    />
                    <Route
                        path="/hr/funcionarios/:id/edit"
                        element={<HrEmployeeFormPage />}
                    />
                    <Route
                        path="/hr/payroll"
                        element={<PayrollRunsListPage />}
                    />
                    <Route
                        path="/hr/payroll/:id"
                        element={<PayrollRunDetailPage />}
                    />
                    <Route path="/hr/rubrics" element={<RubricsPage />} />
                    <Route path="/hr/tabelas" element={<PayrollTablesPage />} />
                    <Route path="/hr/vacations" element={<VacationsPage />} />
                    <Route
                        path="/hr/time-tracking"
                        element={<TimeTrackingPage />}
                    />
                    <Route path="/hr/esocial" element={<EsocialPage />} />
                    <Route path="/hr/hour-bank" element={<HourBankPage />} />
                    {/* Marketing */}
                    <Route
                        path="/marketing/dashboard"
                        element={<MarketingDashboardPage />}
                    />
                    <Route
                        path="/marketing/campaigns"
                        element={<CampaignsListPage />}
                    />
                    <Route
                        path="/marketing/campaigns/new"
                        element={<CampaignFormPage />}
                    />
                    <Route
                        path="/marketing/campaigns/:id"
                        element={<CampaignDetailPage />}
                    />
                    <Route
                        path="/marketing/campaigns/:id/edit"
                        element={<CampaignFormPage />}
                    />
                    <Route
                        path="/marketing/meta"
                        element={<MetaIntegrationPage />}
                    />
                    <Route
                        path="/marketing/google-ads"
                        element={<GoogleAdsIntegrationPage />}
                    />
                    <Route
                        path="/marketing/tiktok-ads"
                        element={<TikTokAdsIntegrationPage />}
                    />
                    <Route
                        path="/marketing/events"
                        element={<MarketingEventsPage />}
                    />
                    <Route
                        path="/marketing/site-banners"
                        element={<SiteBannersListPage />}
                    />
                    <Route
                        path="/marketing/site-banners/new"
                        element={<SiteBannerFormPage />}
                    />
                    <Route
                        path="/marketing/site-banners/edit/:id"
                        element={<SiteBannerFormPage />}
                    />
                    {/* Mensageria */}
                    <Route
                        path="/messaging/whatsapp-templates"
                        element={<WhatsappTemplatesPage />}
                    />
                    <Route
                        path="/messaging/whatsapp-templates/new"
                        element={<WhatsappTemplateFormPage />}
                    />
                    <Route
                        path="/messaging/whatsapp-templates/edit/:id"
                        element={<WhatsappTemplateFormPage />}
                    />
                    <Route
                        path="/messaging/quick-messages"
                        element={<QuickMessagesPage />}
                    />
                    <Route
                        path="/messaging/quick-messages/new"
                        element={<QuickMessageFormPage />}
                    />
                    <Route
                        path="/messaging/quick-messages/edit/:id"
                        element={<QuickMessageFormPage />}
                    />
                    <Route
                        path="/messaging/whatsapp-account"
                        element={<WhatsappAccountPage />}
                    />
                    <Route
                        path="/messaging/settings"
                        element={<MessagingSettingsPage />}
                    />
                    <Route
                        path="/messaging/whatsapp-broadcasts"
                        element={<WhatsappBroadcastsPage />}
                    />
                    <Route
                        path="/messaging/whatsapp-broadcasts/new"
                        element={<WhatsappBroadcastFormPage />}
                    />
                    <Route
                        path="/messaging/whatsapp-broadcasts/edit/:id"
                        element={<WhatsappBroadcastFormPage />}
                    />
                    <Route
                        path="/messaging/whatsapp-broadcasts/:id"
                        element={<WhatsappBroadcastDetailPage />}
                    />
                    {/* Vendas */}
                    <Route path="/sales" element={<SalesDashboardPage />} />
                    <Route
                        path="/sales/settings"
                        element={<SalesConfigPage />}
                    />
                    <Route
                        path="/sales/wallets"
                        element={<WalletsListPage />}
                    />
                    <Route
                        path="/sales/wallets/unassigned"
                        element={<UnassignedClientsPage />}
                    />
                    <Route
                        path="/sales/pipelines"
                        element={<PipelinesListPage />}
                    />
                    <Route
                        path="/sales/pipelines/:id"
                        element={<PipelineDetailPage />}
                    />
                    <Route path="/sales/leads" element={<LeadsListPage />} />
                    <Route
                        path="/sales/leads/:id"
                        element={<SalesLeadDetailPage />}
                    />
                    <Route path="/sales/deals" element={<DealsListPage />} />
                    <Route
                        path="/sales/deals/:id"
                        element={<DealDetailPage />}
                    />
                    {/* Follow-up virou fluxo (docs/sales-flows.md): endereço antigo leva à tela nova. */}
                    <Route
                        path="/sales/follow-ups"
                        element={<Navigate to="/sales/automations" replace />}
                    />
                    <Route path="/sales/slas" element={<SLAsPage />} />
                    {/* Automações e fluxos (docs/sales-flows.md). As telas antigas de
                        automação saíram; os endereços delas levam à tela nova. */}
                    <Route
                        path="/sales/automations"
                        element={<FlowsPage />}
                    />
                    <Route
                        path="/sales/automations/flows/:id"
                        element={<FlowEditorPage />}
                    />
                    <Route
                        path="/sales/automations/*"
                        element={<Navigate to="/sales/automations" replace />}
                    />
                    <Route
                        path="/sales/gamification"
                        element={<GamificationPage />}
                    />
                    {/* Administrative - Contratos */}
                    <Route
                        path="/administrative/contracts"
                        element={<ContractsListPage />}
                    />
                    <Route
                        path="/administrative/contracts/:id"
                        element={<ContractPage />}
                    />
                    {/* Administrative - Revendas */}
                    <Route
                        path="/administrative/resales"
                        element={<ResalesListPage />}
                    />
                    <Route
                        path="/administrative/resales/new"
                        element={<ResaleFormPage />}
                    />
                    <Route
                        path="/administrative/resales/:id"
                        element={<ResaleFormPage />}
                    />
                    <Route
                        path="/commerce/subscriptions"
                        element={<SignDocumentsListPage />}
                    />
                    <Route
                        path="/commerce/subscriptions/new"
                        element={<SignDocumentFormPage />}
                    />
                    <Route
                        path="/commerce/subscriptions/:id"
                        element={<SignDocumentDetailPage />}
                    />
                    {/* Administrative - Inbox */}
                    <Route
                        path="/administrative/inbox"
                        element={<InboxPage />}
                    />
                    <Route
                        path="/administrative/inbox/contas"
                        element={<InboxAccountsPage />}
                    />
                    <Route
                        path="/administrative/inbox/templates"
                        element={<InboxTemplatesPage />}
                    />
                    {/* Fiscal */}
                    <Route
                        path="/fiscal/invoices"
                        element={<FiscalNotesPage />}
                    />
                    <Route
                        path="/fiscal/invoices/nfe"
                        element={<NfeFormPage />}
                    />
                    <Route
                        path="/fiscal/invoices/nfse"
                        element={<NfseFormPage />}
                    />
                    <Route
                        path="/fiscal/invoices/:id"
                        element={<FiscalNoteDetailPage />}
                    />
                    <Route
                        path="/fiscal/settings"
                        element={<FiscalSettingsPage />}
                    />
                    {/* Security / Permissions */}
                    <Route
                        path="/security/permissions"
                        element={<PermissionsPage />}
                    />
                    <Route
                        path="/security/permissions/:id"
                        element={<RoleDetailPage />}
                    />
                    <Route
                        path="/security/permissions/new"
                        element={<RoleFormPage />}
                    />
                    <Route
                        path="/security/permissions/edit/:id"
                        element={<RoleFormPage />}
                    />
                    <Route path="/security/events" element={<EventsPage />} />
                    {/* Notifications */}
                    <Route
                        path="/notifications"
                        element={<NotificationsPage />}
                    />
                    <Route
                        path="/notifications/new"
                        element={<NotificationFormPage />}
                    />
                    {/* Import Review */}
                    <Route
                        path="/core/import/review/:id"
                        element={<ImportReviewPage />}
                    />
                    {/* Internal Chat */}
                    <Route
                        path="/core/internal-chat"
                        element={<InternalChatPage />}
                    />
                    <Route
                        path="/core/internal-chat/:conversationId"
                        element={<InternalChatPage />}
                    />
                    {/*
                        Compatibilidade: o núcleo agendável saiu de /medical/* para
                        /bookings/*. Links salvos pelo usuário e o `link` de notificações
                        antigas continuam apontando para o caminho velho — estes redirects
                        preservam o id e a query string. Manter enquanto houver notificação
                        anterior à migração no histórico.
                    */}
                    {LEGACY_MEDICAL_ROUTES.map(resource => (
                        <Route
                            key={resource}
                            path={`/medical/${resource}/*`}
                            element={<LegacyMedicalRedirect />}
                        />
                    ))}
                    {/*
                        Mesma compatibilidade para /registrations/medical-supplies,
                        que virou /registrations/supplies: "medical" no endereço não
                        cabe num salão que cadastra material de beleza.
                    */}
                    <Route
                        path="/registrations/medical-supplies/*"
                        element={<LegacySuppliesRedirect />}
                    />
                    <Route
                        path="/fiscal/certificates"
                        element={<LegacyFiscalCertificatesRedirect />}
                    />
                    {/* Fallback: rota desconhecida ou sem acesso volta para o inicio */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        </RegistrationGuard>
    )
}

export default AdminRoutes
